import PropTypes from 'prop-types';
import React, { Component } from 'react';
import phaseLineItemShape from 'types/lineItemPropType';
import { cutQuantityString } from '../../../../../../../../utils/lineItemUtils';
import ItemEvents from 'components/LineItemTable/itemEvents';
import LineItemStatus from 'lineItemStatus';
import InputCell from 'components/LineItemTable/inputCell';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import { Button } from 'react-toolbox/lib/button';
import styles from './styles.scss';
import S from 'styles/table.scss';

class WarehousePadTableRow extends Component {
  static NET_QUANTITY_MISSING_MESSAGE = 'Net square footage missing.';

  static parseNetQuantity(value) {
    if (value === '' || value === null || value === undefined) return null;
    const trimmed = String(value).trim();
    if (!/^[-+]?\d+(\.\d+)?$/.test(trimmed)) return null;
    const parsed = parseFloat(trimmed);
    return Number.isNaN(parsed) ? null : parsed;
  }

  constructor(props) {
    super();
    const { net_quantity: netQuantity } = props.lineItem;
    this.state = {
      netQuantity: WarehousePadTableRow.parseNetQuantity(netQuantity),
    };
    this.rowRef = React.createRef();
  }
  handleWarehouseStatus = (lineItem) => {
    const submitObject = {
      warehouse_status: lineItem.status,
      id: this.props.lineItem.id,
    };
    this.props.onSave(submitObject);
  }

  updateNetQuantityAndMarkDirty = (netQuantity) => {
    const row = this.rowRef.current;
    if (row && typeof row.setDirtyState === 'function') {
      row.setDirtyState(true);
    }
    this.setState({ netQuantity });
  };

  handleIncreaseNetQuantity = () => {
    const netQuantity = (this.state.netQuantity || 0) + 1;
    this.updateNetQuantityAndMarkDirty(netQuantity);
  };

  handleDecreaseNetQuantity = () => {
    const netQuantity = (this.state.netQuantity || 0) - 1;
    this.updateNetQuantityAndMarkDirty(netQuantity);
  };

  handleNetQuantityInputChange = (event) => {
    const { value } = event.target;
    const netQuantity = WarehousePadTableRow.parseNetQuantity(value);
    this.updateNetQuantityAndMarkDirty(netQuantity);
  }

  handleSave = () => {
    const { lineItem } = this.props;
    this.props.onSave({
      id: lineItem.id,
      net_quantity: this.state.netQuantity,
    });
  }

  renderStatus = () => {
    const { lineItem, readOnly } = this.props;
    if (readOnly) {
      return lineItem.warehouse_status || '';
    }
    return (
      <LineItemStatus
        onChange={this.handleWarehouseStatus}
        lineItem={{ status: lineItem.warehouse_status }}
        options={['Not Cut', 'Cut', 'Released']}
      />
    );
  }

  renderNetQuantity = () => {
    const { lineItem, readOnly } = this.props;
    if (readOnly) {
      return (
        <EditableTableCell
          label="Net Quantity"
          value={this.state.netQuantity === null
            ? WarehousePadTableRow.NET_QUANTITY_MISSING_MESSAGE
            : this.state.netQuantity}
        />
      );
    }
    const lineItemWithState = {
      ...lineItem,
      net_quantity: this.state.netQuantity,
    };
    return (
      <InputCell
        key={`net-quantity-${lineItem.id}`}
        attr="net_quantity"
        label="Net Quantity"
        lineItem={lineItemWithState}
        onChange={this.handleNetQuantityInputChange}
        cellValue={this.state.netQuantity === null ? '' : this.state.netQuantity}
        type="number"
      />
    );
  }

  renderCutQuantity = () => {
    const { lineItem } = this.props;
    const cutQuantityValue = cutQuantityString(lineItem.warehouse_quantity);
    return (
      <div className={styles.cutQuantityContainer}>
        {cutQuantityValue}
        <div className={styles.cutQuantityActions}>
          <Button
            theme={styles}
            icon="arrow_upward"
            floating
            ripple
            primary
            onClick={(e) => {
              e.stopPropagation();
              this.handleIncreaseNetQuantity();
            }}
          />
          <Button
            theme={styles}
            icon="arrow_downward"
            floating
            ripple
            primary
            onClick={(e) => {
              e.stopPropagation();
              this.handleDecreaseNetQuantity();
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const { lineItem, readOnly } = this.props;
    const cutQuantityValue = cutQuantityString(lineItem.warehouse_quantity);
    const lineItemWithCutQuantity = { ...lineItem, cut_quantity: cutQuantityValue };

    return (
      <EditableTableRow
        ref={this.rowRef}
        key={lineItem.id}
        id={lineItem.id}
        onSave={!readOnly ? this.handleSave : undefined}
      >
        <ItemEvents
          display={!this.context.isEditable}
          label=""
          itemType="phaseLineItems"
          lineItem={lineItemWithCutQuantity}
          dataKeys={['po_number', 'net_quantity', 'cut_quantity', 'total', 'status']}
        />
        <EditableTableCell label="Item #" value={lineItem.item_number || ''} cellReadOnly />
        <EditableTableCell label="Item Name" value={lineItem.description || ''} cellReadOnly />
        {this.renderNetQuantity()}
        <EditableTableCell label="Cut Quantity" value={cutQuantityValue}>
          {this.renderCutQuantity()}
        </EditableTableCell>
        <EditableTableCell label="Status" value={lineItem.warehouse_status || ''} className={S.largeColumn}>
          {this.renderStatus()}
        </EditableTableCell>
      </EditableTableRow>
    );
  }
}

WarehousePadTableRow.contextTypes = {
  onChange: PropTypes.func,
  isEditable: PropTypes.bool,
};

WarehousePadTableRow.propTypes = {
  lineItem: PropTypes.shape(phaseLineItemShape),
  onSave: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default WarehousePadTableRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehousePadTableRow.jsx